import React, { Component } from "react";
import CartContext from "./CartContext";
import { FiRefreshCcw } from "react-icons/fi";
import { Navigate } from "react-router-dom";
import axios from "axios";
import FavList from "./FavList";
import kotItemTemplate from "./kotItem.txt";
import kotTableTemplate from "./kotTable.txt";
import CheckoutTO from "./CheckoutTO";
import IncDecCounter from "./IncDecCounterControl";
import SearchViewTO from "./SearchViewTO.js";
import { OrderSummaryTO } from "./OrderSummaryTO.js";
import { MainCategoryStrip } from "./SearchViewPOS.js";
import Swal from "sweetalert2";

import {
  Button,
  Table,
  Offcanvas,
  Tooltip,
  OverlayTrigger,
  Modal,
  Form,
  Navbar,
  Nav,
  Row,
  Col,
} from "react-bootstrap";

import "../../Components/CSS/tableorder.css"; // small stylesheet (optional)

const WAIT_INTERVAL = 500;

export default class TableOrder extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      showProductListByCategory: false,
      updateCartView: "true",
      havePermissions: false,
      myCart: [],
      selectedTableId: "",
      coupon: { couponCode: "", couponValue: 0 },
      generatedInvoiceOrder: "",
      saleDone: false,
      reload: false,
      goBack: false,
      isDesktop: window.innerWidth >= 900,
      showSideMenu: false, // moved here so parent controls offcanvas
    };
  }

  GoBack = () => {
    this.setState({ goBack: true });
  };

  openSideMenu = () => {
    this.setState({ showSideMenu: true });
  };

  closeSideMenu = () => {
    this.setState({ showSideMenu: false });
  };

  StoreCouponDetails = (couponCode, couponValue) => {
    this.setState({
      coupon: { couponCode: couponCode, couponValue: couponValue },
    });
  };

  Refresh = () => {
    this.setState({ myCart: [] }, () => {
      this.GetRestaturantTableOrderByTableId(this.state.selectedTableId);
    });
  };

  GetRestaturantTableOrderByTableId = (tableId) => {
    fetch(
      process.env.REACT_APP_API +
        "Consumers/GetRestaturantTableOrderByTableId/" +
        tableId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data && data.status === 400) {
        } else {
          this.setState({ myCart: data || [] });
        }
      })
      .catch((err) => {
        console.error("GetRestaturantTableOrderByTableId error:", err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to load table orders.",
        });
      });
  };

  AddRestaurantTableOrderItem = (item) => {
    // prevent adding when locked (defensive check)
    if (this.state.generatedInvoiceOrder !== "") {
      Swal.fire({
        icon: "info",
        title: "Order locked",
        text: "Bill already generated — cannot add items.",
        timer: 1200,
        showConfirmButton: false,
      });
      return;
    }

    var orderItem = {
      tableId: this.state.selectedTableId,
      productId: item.prod.id,
      fileName: item.prod.imgFileName,
      productName: item.prod.name,
      mrp: item.prod.mrp,
      discount: item.prod.discount,
      qty: item.qty,
      orderStatusId: "1",
      seqNo: this.state.myCart.length + 1,
      sku: item.prod.sku,
    };
    axios
      .post(
        process.env.REACT_APP_API + "Consumers/AddRestaurantTableOrderItem",
        orderItem
      )
      .then((response) => {
        if (response.status === 200) {
          this.GetRestaturantTableOrderByTableId(this.state.selectedTableId);
          Swal.fire({
            icon: "success",
            title: "Added",
            text: "Added to cart",
            timer: 900,
            showConfirmButton: false,
          });
        } else if (response.status === 204) {
          Swal.fire({
            icon: "warning",
            title: "Out of stock",
            text: "This product is out of stock. Check inventory.",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: "Order submit failed. Please try again!",
          });
        }
      })
      .catch((error) => {
        console.error("AddRestaurantTableOrderItem: error", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong while adding item.",
        });
      });
  };

  UpdateRestaurantTableOrderItem = (item) => {
    if (this.state.generatedInvoiceOrder !== "") {
      Swal.fire({
        icon: "info",
        title: "Order locked",
        text: "Bill already generated — cannot modify items.",
        timer: 1200,
        showConfirmButton: false,
      });
      return;
    }

    axios
      .post(
        process.env.REACT_APP_API +
          "Consumers/UpdateRestaurantTableOrderedItem",
        item
      )
      .then((response) => {
        if (response.status === 200) {
          this.GetRestaturantTableOrderByTableId(this.state.selectedTableId);
        } else {
          Swal.fire({
            icon: "error",
            title: "Update failed",
            text: "UpdateRestaurantTableOrderItem failed. Please try again!",
          });
        }
      })
      .catch((error) => {
        console.error("UpdateRestaurantTableOrderItem: error", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Could not update order item.",
        });
      });
  };

  DeleteRestaurantTableOrderedItem = (id) => {
    if (this.state.generatedInvoiceOrder !== "") {
      Swal.fire({
        icon: "info",
        title: "Order locked",
        text: "Bill already generated — cannot delete items.",
        timer: 1200,
        showConfirmButton: false,
      });
      return;
    }

    axios
      .post(
        process.env.REACT_APP_API +
          "Consumers/DeleteRestaurantTableOrderedItem/" +
          id
      )
      .then((response) => {
        if (response.status === 200) {
          this.GetRestaturantTableOrderByTableId(this.state.selectedTableId);
        } else {
          Swal.fire({
            icon: "error",
            title: "Delete failed",
            text: "Try again!",
          });
        }
      })
      .catch((error) => {
        console.error("DeleteRestaurantTableOrderedItem: error", error);
        Swal.fire({ icon: "error", title: "Error", text: "Delete failed." });
      });
  };

  UpdateCartView = () => {
    this.setState({ myCart: [] }, () => {
      window.scrollTo(0, 0);
    });
  };

  GetOrderByOrderId = (invoiceNumber) => {
    axios
      .get(
        process.env.REACT_APP_API +
          "Consumers/GetOrderByOrderId/" +
          this.context.storeId +
          "/" +
          invoiceNumber
      )
      .then((response) => {
        if (response.status === 200) {
          this.setState({ generatedInvoiceOrder: response.data }, () => {
            this.setState({ reload: true }, () => {
              this.setState({ reload: false });
            });
          });
        }
      })
      .catch((error) => {
        console.error("GetOrderByOrderId: error", error);
      });
  };

  StoreGeneratedInvoice = (invoiceOrder) => {
    this.setState({ generatedInvoiceOrder: invoiceOrder });
  };

  SaleDone = () => {
    this.setState({ saleDone: true });
    this.context.GetRestaturantTables();
  };

  componentDidMount = () => {
    this.setState({ selectedTableId: this.context.selectedTable.id }, () => {
      this.GetRestaturantTableOrderByTableId(this.context.selectedTable.id);
      if (
        this.context.selectedTable.invoiceNumber &&
        this.context.selectedTable.invoiceNumber !== ""
      ) {
        this.GetOrderByOrderId(this.context.selectedTable.invoiceNumber);
      }
    });

    window.addEventListener("resize", this.handleResize);

    // load templates (kept for parity with original)
    fetch(kotItemTemplate).catch(() => {});
    fetch(kotTableTemplate).catch(() => {});

    this.context.UpdateTableOrderStatus("");
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    const isDesktop = window.innerWidth >= 900;
    if (this.state.isDesktop !== isDesktop) this.setState({ isDesktop });
  };

  componentDidUpdate = () => {
    this.context.SetQtyInCartModified(false);
  };

  render() {
    if (this.state.saleDone === true) return <Navigate to="/TableOrders" />;
    if (this.context.storeId === "") return <Navigate to="/home" />;
    if (this.state.goBack) return <Navigate to="/TableOrders" />;

    const isDesktop = this.state.isDesktop;

    const selectedTable = this.context?.selectedTable
      ? this.context.getTableById(this.context.selectedTable.id)
      : null;
    const tableName = selectedTable?.name || "—";
    const waiterName = selectedTable?.waiterName || "—";

    // global lock: true when bill has been generated
    const isLocked = this.state.generatedInvoiceOrder !== "";

    return (
      <>
        {this.state.selectedTableId === "" ? (
          ""
        ) : (
          <>
            {isDesktop ? (
              <div
                className="py-0 border border-info page-container"
                style={{ paddingBottom: "120px" }}
              >
                <div
                  className="table-order-header d-flex align-items-center justify-content-between p-2"
                  style={{
                    backgroundColor: "cyan",
                    color: this.context.posTextColor,
                    pointerEvents: isLocked ? "none" : "auto", // visually block header when locked
                    opacity: isLocked ? 0.7 : 1,
                  }}
                >
                  <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip id="tt-back">Back to all tables</Tooltip>}
                  >
                    <Button
                      variant="secondary"
                      size="sm"
                      className="me-2"
                      onClick={this.GoBack}
                      aria-label="Back to all tables"
                      title="Back to all tables"
                      disabled={isLocked}
                    >
                      ←
                    </Button>
                  </OverlayTrigger>

                  <div className="text-center flex-grow-1">
                    <h4 className="mb-0">
                      <b>TABLE - {tableName}</b>
                    </h4>
                    <small className="ms-0">
                      [Waiter: <i>{waiterName}</i>]
                    </small>
                  </div>

                  <div className="d-flex align-items-center">
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="tt-refresh">Refresh table</Tooltip>}
                    >
                      <Button
                        variant="success"
                        size="sm"
                        className="me-2"
                        onClick={this.Refresh}
                        aria-label="Refresh table"
                        title="Refresh table"
                        disabled={isLocked}
                      >
                        <FiRefreshCcw />
                        <span className="visually-hidden"> Refresh</span>
                      </Button>
                    </OverlayTrigger>

                    {/* KOT intentionally disabled when locked */}
                    {/* <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="tt-kot">Print KOT</Tooltip>}
                    >
                      <Button
                        variant="warning"
                        size="sm"
                        onClick={() => {
                          if (isLocked) {
                            Swal.fire({
                              icon: "info",
                              title: "Order locked",
                              text: "Bill already generated — cannot print KOT.",
                              timer: 1200,
                              showConfirmButton: false,
                            });
                            return;
                          }
                          // otherwise call KOT - if you had an implementation here
                        }}
                        aria-label="Print KOT"
                        title="Print KOT"
                        disabled={isLocked}
                      >
                        KOT
                      </Button>
                    </OverlayTrigger> */}
                  </div>
                </div>

                <Table width="100% m-0 p-0 border border-light">
                  <tbody>
                    <tr className="border border-light p-0 m-0">
                      {this.context.hideFav === true ? (
                        <td
                          className=" m-0 p-0"
                          style={{
                            width: "50%",
                            pointerEvents: isLocked ? "none" : "auto",
                          }}
                        >
                          <SearchViewTO
                            addToCart={(item) =>
                              this.AddRestaurantTableOrderItem(item)
                            }
                            AddRestaurantTableOrderItem={(item) =>
                              this.AddRestaurantTableOrderItem(item)
                            }
                            isLocked={isLocked}
                          />
                        </td>
                      ) : (
                        <td
                          className="p-0 m-0"
                          hidden={this.context.hideFav}
                          style={{
                            width: "50%",
                            pointerEvents: isLocked ? "none" : "auto",
                          }}
                        >
                          <FavList
                            AddRestaurantTableOrderItem={(item) =>
                              this.AddRestaurantTableOrderItem(item)
                            }
                            isLocked={isLocked}
                          />
                        </td>
                      )}

                      <td
                        className="border p-0 m-0"
                        style={{
                          backgroundColor: this.context.posBackgroundColor,
                          width: this.context.hideFav === true ? "50%" : "40%",
                          pointerEvents: "auto",
                        }}
                      >
                        {this.context.qtyInCartModified === false ? (
                          <div
                            className="my-0 fixedTableHightOrderQuque p-0"
                            style={{
                              minHeight: window.innerHeight - 100 + "px",
                              maxHeight: window.innerHeight - 100 + "px",
                              pointerEvents: isLocked ? "none" : "auto",
                            }}
                          >
                            <CartViewTO
                              updateCartView={this.UpdateCartView}
                              myCart={this.state.myCart}
                              selectedTableId={this.state.selectedTableId}
                              addToCart={this.AddRestaurantTableOrderItem}
                              deleteFromCart={
                                this.DeleteRestaurantTableOrderedItem
                              }
                              UpdateOrderItem={
                                this.UpdateRestaurantTableOrderItem
                              }
                              AddRestaurantTableOrderItem={
                                this.AddRestaurantTableOrderItem
                              }
                              // Side menu control props
                              showSideMenu={this.state.showSideMenu}
                              openSideMenu={this.openSideMenu}
                              closeSideMenu={this.closeSideMenu}
                              isLocked={isLocked}
                            />
                          </div>
                        ) : (
                          ""
                        )}

                        {this.context.getTotalQtyInCartTable(
                          this.state.myCart
                        ) > 0 ? (
                          <div
                            className="my-2"
                            style={{
                              pointerEvents: "auto", // BottomSummaryTO stays interactive
                            }}
                          >
                            {this.state.reload === false ? (
                              <BottomSummaryTO
                                StoreCouponDetails={this.StoreCouponDetails}
                                myCart={this.state.myCart}
                                coupon={this.state.coupon}
                                updateCartView={this.UpdateCartView}
                                tableName={
                                  this.context.getTableById(
                                    this.state.selectedTableId
                                  ).name
                                }
                                generatedInvoiceOrder={
                                  this.state.generatedInvoiceOrder
                                }
                                StoreGeneratedInvoice={
                                  this.StoreGeneratedInvoice
                                }
                                SaleDone={this.SaleDone}
                                isLocked={this.props.isLocked} // <-- new
                              />
                            ) : null}
                          </div>
                        ) : null}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            ) : (
              /* mobile branch */
              <div
                className="m-0 w-100 page-container"
                style={{ paddingBottom: "160px" }}
              >
                <div
                  className="table-order-header d-flex align-items-center justify-content-between p-2 bg-info text-dark"
                  style={{
                    pointerEvents: isLocked ? "none" : "auto",
                    opacity: isLocked ? 0.7 : 1,
                  }}
                >
                  <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip id="tt-back">Back to all tables</Tooltip>}
                  >
                    <Button
                      variant="secondary"
                      size="sm"
                      className="me-2"
                      onClick={this.GoBack}
                      disabled={isLocked}
                    >
                      ←
                    </Button>
                  </OverlayTrigger>

                  <div className="text-center flex-grow-1">
                    <h5 className="mb-0 fw-bold">TABLE - {tableName}</h5>
                    <small>
                      [Waiter: <i>{waiterName}</i>]
                    </small>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="tt-refresh">Refresh table</Tooltip>}
                    >
                      <Button
                        variant="success"
                        size="sm"
                        onClick={this.Refresh}
                        disabled={isLocked}
                      >
                        <FiRefreshCcw />
                      </Button>
                    </OverlayTrigger>

                    {/* KOT button disabled when locked */}
                    {/* <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="tt-kot">Print KOT</Tooltip>}
                    >
                      <Button
                        variant="warning"
                        size="sm"
                        onClick={() => {
                          if (isLocked) {
                            Swal.fire({
                              icon: "info",
                              title: "Order locked",
                              text: "Bill already generated — cannot print KOT.",
                              timer: 1200,
                              showConfirmButton: false,
                            });
                            return;
                          }
                          // else KOT handling
                        }}
                        disabled={isLocked}
                      >
                        KOT
                      </Button>
                    </OverlayTrigger> */}
                  </div>
                </div>

                <div className="w-100 m-0 p-0">
                  <div
                    className="p-0 m-0 overflow-scroll border"
                    style={{
                      pointerEvents: isLocked ? "none" : "auto",
                      minHeight: "0px",
                      maxHeight: window.innerHeight / 2 + "px",
                    }}
                  >
                    <SearchViewTO
                      addToCart={(item) =>
                        this.AddRestaurantTableOrderItem(item)
                      }
                      AddRestaurantTableOrderItem={(item) =>
                        this.AddRestaurantTableOrderItem(item)
                      }
                      isLocked={isLocked}
                    />
                  </div>
                  <br />
                  <div>
                    {this.context.qtyInCartModified === false ? (
                      <div
                        className="my-0"
                        style={{
                          pointerEvents: isLocked ? "none" : "auto",
                        }}
                      >
                        <CartViewTO
                          updateCartView={this.UpdateCartView}
                          myCart={this.state.myCart}
                          selectedTableId={this.state.selectedTableId}
                          addToCart={this.AddRestaurantTableOrderItem}
                          deleteFromCart={this.DeleteRestaurantTableOrderedItem}
                          UpdateOrderItem={this.UpdateRestaurantTableOrderItem}
                          showSideMenu={this.state.showSideMenu}
                          openSideMenu={this.openSideMenu}
                          closeSideMenu={this.closeSideMenu}
                          isLocked={isLocked}
                        />
                      </div>
                    ) : null}

                    {this.context.getTotalQtyInCartTable(this.state.myCart) >
                    0 ? (
                      <BottomSummaryTO
                        StoreCouponDetails={this.StoreCouponDetails}
                        myCart={this.state.myCart}
                        coupon={this.state.coupon}
                        updateCartView={this.UpdateCartView}
                        tableName={
                          this.context.getTableById(this.state.selectedTableId)
                            .name
                        }
                        generatedInvoiceOrder={this.state.generatedInvoiceOrder}
                        StoreGeneratedInvoice={this.StoreGeneratedInvoice}
                        SaleDone={this.SaleDone}
                        isLocked={this.props.isLocked} // <-- new
                      />
                    ) : (
                      <div className="p-3">
                        <div className="empty-cart">
                          <h5>No items in order</h5>
                          <p>
                            Tap the menu to add items or use the search box
                            above.
                          </p>
                          <Button
                            variant="primary"
                            onClick={() => {
                              if (isLocked) {
                                Swal.fire({
                                  icon: "info",
                                  title: "Order locked",
                                  text: "Bill already generated — cannot open menu.",
                                  timer: 1200,
                                  showConfirmButton: false,
                                });
                                return;
                              }
                              this.openSideMenu();
                            }}
                            disabled={isLocked}
                          >
                            Open Menu
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </>
    );
  }
}

/* ------------- Subcomponents (kept logic; added isLocked prop support) ------------- */

class CartViewTO extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      forUpdateValue: 1,
      showAddCustomItemModal: false,
      kotitemtemplate: "",
      kottabletemplate: "",
      // showSideMenu removed from local state — parent provides it via props
    };
  }

  forceUpdate = () => {
    this.setState({ forUpdateValue: 0 }, () => {
      this.setState({ forUpdateValue: 1 });
    });
  };

  ShowAddCustomItemModal = () => {
    // respect isLocked
    if (this.props.isLocked) {
      Swal.fire({
        icon: "info",
        title: "Order locked",
        text: "Bill already generated — cannot add custom item.",
        timer: 1200,
        showConfirmButton: false,
      });
      return;
    }
    this.setState({ showAddCustomItemModal: true });
  };
  HideAddCustomItemModal = () => {
    this.setState({ showAddCustomItemModal: false });
  };

  OnAddCustomItem = () => {
    this.ShowAddCustomItemModal();
  };

  CloseCartOffCanvas = () => {
    this.props.CloseCartOffCanvas?.();
  };
  OnOrderStatusChange = (e, cartItem) => {
    if (this.props.isLocked) {
      Swal.fire({
        icon: "info",
        title: "Order locked",
        text: "Bill already generated — cannot change status.",
        timer: 1200,
        showConfirmButton: false,
      });
      return;
    }
    cartItem.orderStatusId = e.target.value;
    this.props.UpdateOrderItem(cartItem);
  };

  onTabkeKot = () => {
    if (this.props.isLocked) {
      Swal.fire({
        icon: "info",
        title: "Order locked",
        text: "Bill already generated — cannot print KOT.",
        timer: 1200,
        showConfirmButton: false,
      });
      return;
    }

    if (this.props.myCart.length > 0) {
      var table = this.context.getTableById(this.props.selectedTableId);
      var text = this.state.kottabletemplate || "";
      text = text.replace("{{storename}}", this.context.store.name);
      text = text.replace(
        "{{Date}}",
        this.context.GetInDateFormat(new Date()) +
          "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
          new Date().toLocaleString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
      );
      text = text.replace(
        "{{tablename}}",
        table.name + "<br/>Waiter: " + table.waiterName
      );

      var items = "";
      var totqty = 0;
      this.props.myCart
        .filter((f) => f.orderStatusId == 1)
        .map((item, i) => {
          var itemhtml =
            "<tr><td><h3>{{no}}</h3></td> <td style='text-align: start'><h3>{{prodname}}</h3></td> <td><h3>{{qty}}</h3></td> </tr>";
          itemhtml = itemhtml.replace("{{no}}", i + 1);
          itemhtml = itemhtml.replace("{{prodname}}", item.productName);
          itemhtml = itemhtml.replace("{{qty}}", item.qty);

          totqty += item.qty;
          items += itemhtml;
          return null;
        });
      text = text.replace("{{Items}}", items);
      text = text.replace("{{TotalQty}}", totqty);

      var printWindow = window.open("", "_blank");
      printWindow.document.write(text);
      printWindow.document.close();
      this.onPrintFinished(printWindow.print(), printWindow);
    } else {
      Swal.fire({
        icon: "info",
        title: "Nothing to print",
        text: "No new items to print.",
      });
    }
  };

  onItemKot = (cartitem) => {
    if (this.props.isLocked) {
      Swal.fire({
        icon: "info",
        title: "Order locked",
        text: "Bill already generated — cannot print KOT.",
        timer: 1200,
        showConfirmButton: false,
      });
      return;
    }

    var table = this.context.getTableById(cartitem.tableId);
    var text = this.state.kotitemtemplate || "";
    text = text.replace("{{storename}}", this.context.store.name);
    text = text.replace("{{Date}}", this.context.GetInDateFormat(new Date()));
    text = text.replace("{{tablename}}", table.name);
    text = text.replace("{{prodname}}", cartitem.productName);
    text = text.replace("{{prodqty}}", cartitem.qty);

    var printWindow = window.open("", "_blank");
    printWindow.document.write(text);
    printWindow.document.close();
    this.onPrintFinished(printWindow.print(), printWindow);
  };

  getOS = () => {
    var uA = navigator.userAgent || navigator.vendor || window.opera;
    if (
      (/iPad|iPhone|iPod/.test(uA) && !window.MSStream) ||
      (uA.includes("Mac") && "ontouchend" in document)
    )
      return "iOS";

    var i,
      os = ["Windows", "Android", "Unix", "Mac", "Linux", "BlackBerry"];
    for (i = 0; i < os.length; i++)
      if (new RegExp(os[i], "i").test(uA)) return os[i];
  };

  onPrintFinished = (status, printWindow) => {
    var osvar = this.getOS();
    if (osvar == "Windows") printWindow.close();
  };

  componentDidMount() {
    window.scrollTo(0, 0);

    fetch(kotItemTemplate)
      .then((r) => r.text())
      .then((text) => {
        this.setState({ kotitemtemplate: text });
      });
    fetch(kotTableTemplate)
      .then((r) => r.text())
      .then((text) => {
        this.setState({ kottabletemplate: text });
      });

    this.context.UpdateTableOrderStatus("");
  }

  render() {
    if (this.context.storeId == "") return <Navigate to="/home" />;
    if (this.state.forUpdateValue == 0) return "";
    const isLocked = this.props.isLocked === true;

    return (
      <>
        {this.state.showAddCustomItemModal === true ? (
          <AddCustomItem
            onHide={this.HideAddCustomItemModal}
            addToCart={this.props.addToCart}
            isLocked={isLocked}
          />
        ) : null}

        {/* Offcanvas controlled by parent via props */}
        {this.props.showSideMenu ? (
          <SideMenuTO
            handleClose={() =>
              this.props.closeSideMenu && this.props.closeSideMenu()
            }
            addToCart={(item) => {
              if (isLocked) {
                Swal.fire({
                  icon: "info",
                  title: "Order locked",
                  text: "Bill already generated — cannot add items.",
                  timer: 1200,
                  showConfirmButton: false,
                });
                return;
              }
              this.props.addToCart(item);
              // optional: close the offcanvas after adding
              this.props.closeSideMenu && this.props.closeSideMenu();
            }}
            AddRestaurantTableOrderItem={(item) => {
              if (isLocked) {
                Swal.fire({
                  icon: "info",
                  title: "Order locked",
                  text: "Bill already generated — cannot add items.",
                  timer: 1200,
                  showConfirmButton: false,
                });
                return;
              }
              this.props.addToCart(item);
              this.props.closeSideMenu && this.props.closeSideMenu();
            }}
            isLocked={isLocked}
          />
        ) : null}

        {window.innerWidth > 900 ? (
          <div
            className="m-0 p-0 border-0 "
            style={{
              minHeight: window.innerHeight - 100 + "px",
              maxHeight: window.innerHeight - 100 + "px",
              backgroundColor: this.context.cartBackgroundColor,
              color: "black",
            }}
          >
            {/* desktop order view (unchanged) */}
            <Table className="w-100 p-0 m-0 border-0">
              <tbody>
                <tr
                  className="text-start  text-white my-0"
                  style={{
                    backgroundColor: this.context.cartBorderColor,
                    color: "white",
                    opacity: isLocked ? 0.7 : 1,
                    pointerEvents: isLocked ? "none" : "auto",
                  }}
                >
                  <td className="col-md-6">
                    <div className=" text-start">
                      <h4>
                        <i className="bi bi-cart-check" />
                        &nbsp;<b>ORDER</b>
                      </h4>
                    </div>
                  </td>

                  <td className="col-md-4 text-end ">
                    <Button
                      className="bg-secondary text-white"
                      variant="primary "
                      onClick={this.OnAddCustomItem}
                      disabled={isLocked}
                    >
                      &nbsp;&nbsp;+ Add Custom Item&nbsp;&nbsp;
                    </Button>
                  </td>

                  <td className="col-md-2 text-center">
                    <Button
                      className="bg-warning text-dark fw-bold"
                      onClick={(e) => this.onTabkeKot()}
                      disabled={isLocked}
                    >
                      &nbsp;&nbsp;KOT&nbsp;&nbsp;
                    </Button>
                  </td>
                </tr>
              </tbody>
            </Table>

            {/* table of cart items */}
            <Table
              borderless
              className="w-100  m-0 p-0  bg-white "
              responsive="md"
            >
              <thead>
                <tr
                  className="text-center border-0  text-dark m-0 p-0"
                  style={{
                    fontSize: "10pt",
                    backgroundColor: this.context.posBackgroundColor,
                    color: "black",
                  }}
                >
                  <th width="2%"></th>
                  <th width="8%"></th>
                  <th width="23%" className="text-start"></th>
                  <th width="8%">Price</th>
                  <th width="17%">Qty</th>
                  <th width="10%">S.Tot</th>
                  <th width="20%">Status</th>
                  <th width="5%"></th>
                </tr>
              </thead>
              <tbody>
                {this.props.myCart
                  .sort((a, b) => (a.seqNo > b.seqNo ? 1 : -1))
                  .map((cartitem, i) => (
                    <tr
                      key={cartitem.id || `${i}-${cartitem.productName}`}
                      className="text-center align-middle text-white py-2 my-5 border border-secondary"
                      style={{
                        backgroundColor:
                          this.context.productCardBackgroundColor,
                      }}
                    >
                      <td>{i + 1}</td>
                      {cartitem.fileName == undefined ||
                      cartitem.fileName == null ||
                      cartitem.fileName == "" ? (
                        <td></td>
                      ) : (
                        <td>
                          <img
                            src={
                              this.context.store.storageBlobUrl +
                              this.context.store.storageBlobContainerName +
                              "/images/" +
                              cartitem.fileName +
                              this.context.store.storageSasToken
                            }
                            className="cardprodimg-on-cartview mx-auto  rounded-circle"
                            alt={cartitem.productName}
                            style={{ cursor: "pointer", width: "1cm" }}
                          />
                        </td>
                      )}

                      <td className=" text-start ">
                        <strong className="mx-1">{cartitem.productName}</strong>
                        {cartitem.sku ? (
                          <span style={{ fontSize: "12px" }}>
                            <small>&nbsp; SKU: {cartitem.sku}</small>
                          </span>
                        ) : null}
                      </td>

                      <td>
                        {Number(cartitem.mrp).toLocaleString(
                          this.context.storeSettings.defaultLocale,
                          {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 1,
                            style: "currency",
                            currency:
                              this.context.storeSettings.defaultCurrency,
                          }
                        )}
                      </td>

                      <td className=" text-center">
                        <IncDecCounter
                          intvalue={cartitem.qty}
                          disabled={cartitem.orderStatusId != 1 || isLocked}
                          valueChangeCallback={(e) => {
                            if (isLocked) {
                              Swal.fire({
                                icon: "info",
                                title: "Order locked",
                                text: "Bill already generated — cannot change quantity.",
                                timer: 1200,
                                showConfirmButton: false,
                              });
                              return;
                            }
                            cartitem.qty = e;
                            this.props.UpdateOrderItem(cartitem);
                          }}
                        />
                      </td>

                      <td>
                        <strong>
                          {Number(
                            cartitem.qty *
                              (cartitem.mrp -
                                (cartitem.mrp * cartitem.discount) / 100)
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 1,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </strong>
                      </td>

                      <td>
                        <Form.Select
                          value={cartitem.orderStatusId}
                          size="lg"
                          style={{
                            fontWeight: "bold",
                            color:
                              cartitem.orderStatusId == 1
                                ? "blue"
                                : cartitem.orderStatusId == 2
                                ? "red"
                                : cartitem.orderStatusId == 3
                                ? "green"
                                : cartitem.orderStatusId == 4
                                ? "black"
                                : "",
                          }}
                          required
                          onChange={(e) =>
                            this.OnOrderStatusChange(e, cartitem)
                          }
                          disabled={isLocked}
                        >
                          {this.context.restaurantTableOrdereStatus.map(
                            (sta) => (
                              <option key={sta.id} value={sta.id}>
                                {sta.orderStatus}
                              </option>
                            )
                          )}
                        </Form.Select>
                      </td>

                      <td>
                        <OverlayTrigger overlay={<Tooltip>Delete!</Tooltip>}>
                          <Button
                            variant="outline-black"
                            onClick={(e) => {
                              if (isLocked) {
                                Swal.fire({
                                  icon: "info",
                                  title: "Order locked",
                                  text: "Bill already generated — cannot delete items.",
                                  timer: 1200,
                                  showConfirmButton: false,
                                });
                                return;
                              }
                              if (window.confirm("Do you want to Delete?")) {
                                this.props.deleteFromCart(cartitem.id);
                              }
                            }}
                            disabled={isLocked}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="white"
                              className="bi bi-trash"
                              viewBox="0 0 16 16"
                            >
                              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                              <path
                                fillRule="evenodd"
                                d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                              />
                            </svg>
                          </Button>
                        </OverlayTrigger>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <>
            {/* mobile view */}
            <div>
              <table className="w-100 ">
                <tbody>
                  <tr
                    className="text-start text-dark "
                    style={{ backgroundColor: "cyan" }}
                  >
                    <td className="border-0">
                      <div className="text-dark text-start py-2">
                        <h5>
                          <i className="bi bi-cart-check" />
                          &nbsp;<b>ORDER</b>
                        </h5>
                      </div>
                    </td>
                    <td className="text-center border-0">
                      <Button
                        className="mx-2 border-white "
                        style={{ backgroundColor: "darkgreen" }}
                        onClick={this.OnAddCustomItem}
                        disabled={isLocked}
                      >
                        + Custom
                      </Button>
                    </td>
                    <td className="col-md-2 text-center">
                      <Button
                        className="CornersRounded"
                        variant="danger"
                        onClick={(e) => this.onTabkeKot()}
                        disabled={isLocked}
                      >
                        &nbsp;&nbsp;KOT&nbsp;&nbsp;
                      </Button>
                    </td>
                    <td className="text-center">
                      <Button
                        className=" bg-dark"
                        onClick={() =>
                          this.props.openSideMenu && this.props.openSideMenu()
                        }
                        disabled={isLocked}
                      >
                        &nbsp;&nbsp;Menu&nbsp;&nbsp;
                      </Button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <Table className="w-100  m-0 p-0 border-dark bg-white" size="sm">
                <thead>
                  <tr
                    className="text-center bg-light text-dark"
                    style={{ fontSize: "12pt" }}
                  >
                    <th width="35%">Item</th>
                    <th width="30%">Qty</th>
                    <th width="30%">Status</th>
                    <th width="5%"></th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.myCart
                    .sort((a, b) => (a.seqNo > b.seqNo ? 1 : -1))
                    .map((cartitem, i) => (
                      <tr
                        key={cartitem.id || `${i}-${cartitem.productName}`}
                        className="text-center align-middle text-black"
                      >
                        <td className=" text-black text-start ">
                          {i + 1}.&nbsp;
                          {cartitem.productName}&nbsp;
                          {Number(
                            cartitem.mrp -
                              (cartitem.mrp * cartitem.discount) / 100
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                          {cartitem.sku ? (
                            <span style={{ fontSize: "12px" }}>
                              <small>&nbsp; SKU: {cartitem.sku}</small>
                            </span>
                          ) : null}
                        </td>
                        <td className=" text-center">
                          <IncDecCounter
                            disabled={
                              cartitem.orderStatusId != 1 ? true : isLocked
                            }
                            intvalue={cartitem.qty}
                            valueChangeCallback={(e) => {
                              if (isLocked) {
                                Swal.fire({
                                  icon: "info",
                                  title: "Order locked",
                                  text: "Bill already generated — cannot change quantity.",
                                  timer: 1200,
                                  showConfirmButton: false,
                                });
                                return;
                              }
                              cartitem.qty = e;
                              this.props.UpdateOrderItem(cartitem);
                            }}
                          />
                        </td>

                        <td className="">
                          <Form.Select
                            value={cartitem.orderStatusId}
                            className="my-2 fw-bold"
                            style={{
                              color:
                                cartitem.orderStatusId == 1
                                  ? "blue"
                                  : cartitem.orderStatusId == 2
                                  ? "red"
                                  : cartitem.orderStatusId == 3
                                  ? "green"
                                  : cartitem.orderStatusId == 4
                                  ? "black"
                                  : "",
                            }}
                            required
                            onChange={(e) =>
                              this.OnOrderStatusChange(e, cartitem)
                            }
                            disabled={isLocked}
                          >
                            {this.context.restaurantTableOrdereStatus.map(
                              (sta) => (
                                <option key={sta.id} value={sta.id}>
                                  {sta.orderStatus}
                                </option>
                              )
                            )}
                          </Form.Select>
                        </td>
                        <td className="text-end">
                          <OverlayTrigger
                            overlay={<Tooltip>Delete!</Tooltip>}
                            popperConfig={{
                              modifiers: {
                                preventOverflow: { enabled: false },
                              },
                            }}
                          >
                            <Button
                              variant="outline-danger"
                              size="sm"
                              disabled={
                                isLocked ||
                                this.context.storeSettings
                                  .disableDeleteOrderItemsOnTableOrder
                              }
                              onClick={(e) => {
                                if (isLocked) {
                                  Swal.fire({
                                    icon: "info",
                                    title: "Order locked",
                                    text: "Bill already generated — cannot delete items.",
                                    timer: 1200,
                                    showConfirmButton: false,
                                  });
                                  return;
                                }
                                if (window.confirm("Do you want to Delete?")) {
                                  this.props.deleteFromCart(cartitem.id);
                                }
                              }}
                            >
                              X
                            </Button>
                          </OverlayTrigger>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>
          </>
        )}
      </>
    );
  }
}

export class AddCustomItem extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      productName: "",
      price: "",
      discount: "",
      qty: "",
      sellingPrice: "",
    };
  }
  handleInputChange = (e) => {
    const { name, value } = e.target;
    switch (name.trim()) {
      case "productName":
        this.setState({ productName: value });
        break;
      case "price":
        this.setState({ price: value });
        break;
      case "discount":
        this.setState({ discount: value });
        break;
      case "qty":
        this.setState({ qty: value });
        break;
    }
  };
  handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();

    if (this.props.isLocked) {
      Swal.fire({
        icon: "info",
        title: "Order locked",
        text: "Bill already generated — cannot add custom item.",
        timer: 1200,
        showConfirmButton: false,
      });
      return;
    }

    if (form.checkValidity() === false) {
      event.stopPropagation();
      return;
    }

    this.props.addToCart({
      prod: {
        id: this.context.GetNewGuid(),
        name: this.state.productName,
        mrp: this.state.price,
        discount: this.state.discount,
      },
      qty: this.state.qty,
    });
    this.props.onHide();
  };
  render() {
    return (
      <>
        <Modal
          {...this.props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={false}
          show={true}
          dialogClassName="payByCash"
        >
          <Form onSubmit={this.handleSubmit}>
            <Modal.Header closeButton className="bg-warning">
              <Modal.Title id="contained-modal-title-vcenter">
                Add Custom Item
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="show-grid ">
              <Form.Group as={Row} className="mb-1 " controlId="">
                <Form.Label column sm="6">
                  <h2>Product Name:</h2>
                </Form.Label>
                <Col sm="6">
                  <Form.Control
                    type="text"
                    size="lg"
                    name="productName"
                    value={this.state.productName}
                    required
                    placeholder=""
                    autoComplete="new-password"
                    onChange={(e) => this.handleInputChange(e)}
                    style={{ fontSize: "26px" }}
                    disabled={this.props.isLocked}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-1 " controlId="">
                <Form.Label column sm="6">
                  <h2>Price:</h2>
                </Form.Label>
                <Col sm="6">
                  <Form.Control
                    type="number"
                    size="lg"
                    name="price"
                    value={this.state.price}
                    required
                    placeholder=""
                    autoComplete="new-password"
                    onChange={(e) => this.handleInputChange(e)}
                    style={{ fontSize: "26px" }}
                    disabled={this.props.isLocked}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-1 " controlId="">
                <Form.Label column sm="6">
                  <h2>Discount(%):</h2>
                </Form.Label>
                <Col sm="6">
                  <Form.Control
                    type="number"
                    size="lg"
                    name="discount"
                    value={this.state.discount}
                    required
                    placeholder=""
                    autoComplete="new-password"
                    onChange={(e) => this.handleInputChange(e)}
                    style={{ fontSize: "26px" }}
                    disabled={this.props.isLocked}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-1 " controlId="">
                <Form.Label column sm="6">
                  <h2>Qty:</h2>
                </Form.Label>
                <Col sm="6">
                  <Form.Control
                    type="number"
                    size="lg"
                    name="qty"
                    value={this.state.qty}
                    required
                    placeholder=""
                    autoComplete="new-password"
                    onChange={(e) => this.handleInputChange(e)}
                    style={{ fontSize: "26px" }}
                    disabled={this.props.isLocked}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-1 " controlId="">
                <Form.Label column sm="6">
                  <h2>Selling Price:</h2>
                </Form.Label>
                <Col sm="6">
                  <h2>
                    {Number(
                      this.state.price * this.state.qty -
                        (this.state.price *
                          this.state.qty *
                          this.state.discount) /
                          100
                    ).toLocaleString(
                      this.context.storeSettings == ""
                        ? "en-IN"
                        : this.context.storeSettings.defaultLocale,
                      {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 1,
                        style: "currency",
                        currency:
                          this.context.storeSettings == ""
                            ? "INR"
                            : this.context.storeSettings.defaultCurrency,
                      }
                    )}
                  </h2>
                </Col>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer className="bg-light">
              <Form.Group>
                <Button
                  variant="primary"
                  size="lg"
                  type="submit"
                  disabled={this.props.isLocked}
                >
                  Add
                </Button>
              </Form.Group>

              <Button variant="danger" size="lg" onClick={this.props.onHide}>
                Cancel
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </>
    );
  }
}

class BottomSummaryTO extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    // BottomSummaryTO remains interactive even when isLocked === true
    return (
      <>
        <div
          className="fixed-bottom border-0 border-primary m-0 p-0 w-100 bottom-summary"
          style={{ backgroundColor: this.context.posBackgroundColor }}
        >
          {window.innerWidth >= 900 ? (
            <Navbar className="position-sticky fixed-bottom m-0 p-0  border-0 border-secondary">
              <Navbar.Collapse className="justify-content-start m-0 p-0 border-0">
                <Row className="w-100">
                  <Col sm={8} className="border-0 border-dark">
                    <Nav className="border-0 m-0 p-0 w-100">
                      <OrderSummaryTO
                        myCart={this.props.myCart}
                        StoreCouponDetails={this.props.StoreCouponDetails}
                        isLocked={this.props.isLocked}
                      />
                    </Nav>
                  </Col>
                  <Col sm={4} className="border-0 border-dark">
                    <Nav>
                      <CheckoutTO
                        myCart={this.props.myCart}
                        coupon={this.props.coupon}
                        updateCartView={this.props.updateCartView}
                        tableName={this.props.tableName}
                        generatedInvoiceOrder={this.props.generatedInvoiceOrder}
                        StoreGeneratedInvoice={this.props.StoreGeneratedInvoice}
                        SaleDone={this.props.SaleDone}
                      />
                    </Nav>
                  </Col>
                </Row>
              </Navbar.Collapse>
            </Navbar>
          ) : (
            <>
              <Navbar className="position-sticky fixed-bottom m-0 p-0  border border-secondary">
                <Navbar.Collapse className=" m-0 p-0 border-0 w-100 bg-danger">
                  <Row className="w-100 border m-0 p-0">
                    <Col sm={12} className="w-100 border m-0 p-0">
                      <Nav className="border-0 m-0 p-0 w-100">
                        <OrderSummaryTO
                          myCart={this.props.myCart}
                          StoreCouponDetails={this.props.StoreCouponDetails}
                          isLocked={this.props.isLocked}
                        />
                      </Nav>
                    </Col>
                  </Row>
                </Navbar.Collapse>
              </Navbar>

              <Navbar className="position-sticky fixed-bottom m-0 p-0 border border-secondary bottom-actions">
                <Navbar.Collapse className="justify-content-start m-0 p-0 ">
                  <Row className="w-100">
                    <Col sm={12}>
                      <Nav>
                        <CheckoutTO
                          myCart={this.props.myCart}
                          coupon={this.props.coupon}
                          updateCartView={this.props.updateCartView}
                          tableName={this.props.tableName}
                          generatedInvoiceOrder={
                            this.props.generatedInvoiceOrder
                          }
                          StoreGeneratedInvoice={
                            this.props.StoreGeneratedInvoice
                          }
                          SaleDone={this.props.SaleDone}
                        />
                      </Nav>
                    </Col>
                  </Row>
                </Navbar.Collapse>
              </Navbar>
            </>
          )}
        </div>
      </>
    );
  }
}

class SideMenuTO extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      searchData: [],
      searchquery: "",
      showProductListByCategory: false,
    };
  }
  SubCategoryClicked = () => {
    this.setState({ searchquery: "" }, () => {
      this.setState({ searchData: [] });
    });
    this.setState({ showProductListByCategory: true });
  };

  render() {
    const isLocked = this.props.isLocked === true;
    return (
      <>
        <Offcanvas
          className="m-0 p-0"
          show={true}
          onHide={this.props.handleClose}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Menu</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body className="m-0 p-0">
            {/* Close offcanvas after adding an item */}
            <SearchViewTO
              addToCart={(item) => {
                if (isLocked) {
                  Swal.fire({
                    icon: "info",
                    title: "Order locked",
                    text: "Bill already generated — cannot add items.",
                    timer: 1200,
                    showConfirmButton: false,
                  });
                  return;
                }
                this.props.addToCart(item);
                this.props.handleClose?.();
              }}
              AddRestaurantTableOrderItem={(item) => {
                if (isLocked) {
                  Swal.fire({
                    icon: "info",
                    title: "Order locked",
                    text: "Bill already generated — cannot add items.",
                    timer: 1200,
                    showConfirmButton: false,
                  });
                  return;
                }
                this.props.addToCart(item);
                this.props.handleClose?.();
              }}
              onOffCanvas={true}
              isLocked={isLocked}
            />
          </Offcanvas.Body>
        </Offcanvas>
      </>
    );
  }
}
